/* eslint-disable */
import { useContext, useState } from 'react';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import P, { shape } from 'prop-types';
import ConfirmationDialog from '../ConfirmationDialog';
import { MainContext } from '../../context/ApiContext';
import UserForm from '../UserForm';
import { MaskedTextField } from '../FormFields';
import { formatPhone } from '../../utils/phoneMask';

const InidicationReportGerVeicTableList = ({
  listItem,
  title,
  states,
  sold,
  status,
  showInviter = true,
  showClientPhone = false,
}) => {
  const [open, setOpen] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [user, setUser] = useState(null);
  const [id, setId] = useState('');
  const [dialog, setDialog] = useState({
    msg: '',
    title: '',
  });
  // console.log(listItem);

  return (
    <>
      <ConfirmationDialog
        open={openConfirm}
        setOpen={setOpenConfirm}
        msg={dialog.msg.length > 0 ? dialog.msg : 'Dialog'}
        title={dialog.title.length > 0 ? dialog.title : 'Dialog'}
      />
      <UserForm open={open} setOpen={setOpen} title={title} user={user} />
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Cliente</TableCell>
              {showClientPhone && <TableCell>Telefone</TableCell>}
              <TableCell>Veículo</TableCell>
              <TableCell>Data Indicação do Vendedor</TableCell>
              <TableCell>Data Venda / Não Venda</TableCell>
              <TableCell>Data Indicação do Processamento</TableCell>
              <TableCell>Data Criação da Proposta</TableCell>
              <TableCell>Consultor de F&I confirmou que cliente tem interesse</TableCell>
              <TableCell>Cliente confirmou que foi informado da Pessego</TableCell>
              <TableCell>Fase</TableCell>
              <TableCell>Status</TableCell>
              {showInviter && <TableCell>Indicador</TableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            {listItem?.map((item) => (
              <TableRow key={item?.id}>
                <TableCell align="left">{item?.id}</TableCell>
                <TableCell>{item?.client || '-'}</TableCell>
                {showClientPhone && <TableCell>{formatPhone(item?.client_phone)}</TableCell>}
                <TableCell>{item?.product || '-'}</TableCell>
                <TableCell>{item?.inviter_indication_time || '-'}</TableCell>
                <TableCell>{item?.sold_date || '-'}</TableCell>
                <TableCell>{item?.process_indication_time || '-'}</TableCell>
                <TableCell>{item?.proposal_date || '-'}</TableCell>

                <TableCell>
                  {item?.fi_referral_accepted === 1 && 'Sim'}
                  {item?.fi_referral_accepted === 0 && 'Não'}
                  {item?.fi_referral_accepted === null && '-'}
                </TableCell>
                <TableCell>
                  {item?.crm_contact_accepted === 1 && 'Sim'}
                  {item?.crm_contact_accepted === 0 && 'Não'}
                  {item?.crm_contact_accepted === 2 && 'Não passou pelo F&I'}
                  {item?.crm_contact_accepted === null && 'Aguardando confirmação'}
                </TableCell>

                <TableCell>{item?.state || '-'}</TableCell>
                <TableCell>{item?.status || '-'}</TableCell>
                {showInviter && <TableCell>{item?.inviter_name || '-'}</TableCell>}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

InidicationReportGerVeicTableList.propTypes = {
  listItem: P.arrayOf(
    shape({
      id: P.number,
      name: P.string,
    })
  ),
  title: P.string.isRequired,
  showInviter: P.bool,
  showClientPhone: P.bool,
};

InidicationReportGerVeicTableList.defaultProps = {
  listItem: null,
  showInviter: true,
  showClientPhone: false,
};

export default InidicationReportGerVeicTableList;
